import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92f85ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-coach-dashboard-statistics-trainings" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Treninzi ", -1))
const _hoisted_5 = { class: "action" }
const _hoisted_6 = { class: "box__period" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Period:", -1))
const _hoisted_8 = {
  key: 0,
  class: "box__list"
}
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "information" }
const _hoisted_13 = {
  key: 1,
  class: "box__message"
}
const _hoisted_14 = { class: "form" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            class: "el-button--grey el-button--square",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDialogVisible = true))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Calendar)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.moment(_ctx.formData.filter.date[0]).format('DD.MM.YYYY.')) + " - " + _toDisplayString(_ctx.moment(_ctx.formData.filter.date[1]).format('DD.MM.YYYY.')), 1)
      ]),
      (_ctx.statistics.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (statistic, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: key
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(statistic.name), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, " Broj treninga: " + _toDisplayString(statistic.count), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statistic.content, (content, contentKey) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "information",
                        key: contentKey
                      }, _toDisplayString(content.name) + ": " + _toDisplayString(content.count), 1))
                    }), 128))
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, " Nema podataka... "))
    ]),
    _createVNode(_component_el_dialog, {
      title: "Period",
      modelValue: _ctx.isDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_form, {
            model: _ctx.formData,
            rules: _ctx.formDataRules,
            ref: "formComponent",
            onSubmit: _withModifiers(_ctx.validateForm, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "Period",
                prop: "filter.date"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: _ctx.formData.filter.date,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.filter.date) = $event)),
                    type: "daterange",
                    format: "DD.MM.YYYY.",
                    "start-placeholder": "Odaberite",
                    "end-placeholder": "Odaberite"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    class: "el-button--primary el-button--block",
                    "native-type": "submit",
                    loading: _ctx.isLoading,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateForm()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Spremi ")
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "onSubmit"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}